let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7JlcF")).then(() => parcelRequire('feaez'));